import script from "./Subscribe.vue?vue&type=script&lang=ts&setup=true"
export * from "./Subscribe.vue?vue&type=script&lang=ts&setup=true"

import "./Subscribe.vue?vue&type=style&index=0&id=b449da66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b449da66"]])

export default __exports__